import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_user_tasks from '@/locales/keys/i18n_page_user_tasks.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_task_update_visibility } from '@/state/generation/user_task/entity/remote_user_task_update_visibility';
import { md } from '@/utils/utils_html';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { RequestUserTaskUpdateVisibility } from '@shared/dto/user_task/_requests/request_user_task_update_visibility';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { useTranslation } from 'react-i18next';

interface Props {
  item: DTO__user_task;
  isSelected?: boolean;
}

export const U_BUTTON__user_task_change_visibility: React.FC<Props> = ({ item, isSelected = false }) => {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_USER_TASKS);

  const i18n_key_tooltip = t(
    item.is_hidden ? i18n_page_user_tasks.button.task_change_visibility.title_show : i18n_page_user_tasks.button.task_change_visibility.title_hide,
  );

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  /*
   *
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let request = new RequestUserTaskUpdateVisibility();
    request.user_task_id = item._id;
    request.is_hidden = !item.is_hidden;

    await dispatch(remote_user_task_update_visibility(request));
  }

  /*
   *
   */
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_UPDATE)) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={i18n_key_tooltip} side="right">
      <UI_PRIMITIVE__button_with_icon_animated
        className="w-7 p-0"
        size="square-5"
        variant="no-border-on-component"
        onClick={onClick}
        iconClassNameBase={`!w-3.5 !h-3.5 ${md(`${isSelected ? '!text-bar' : '!text-component-item-foreground '}`, ``)}`}
        iconClassNameHovered={'!text-bar-foreground'}
        iconClassNameNonHovered={`!text-bar`}
        Icon={item.is_hidden ? ICON__eye_solid : ICON__eye_slash_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
};
